"use strict";
var Observable_1 = require("../../Observable");
var withLatestFrom_1 = require("../../operator/withLatestFrom");
Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/withLatestFrom.js
 ** module id = 443
 ** module chunks = 1
 **/